module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')])]), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_p01_r1"
    }
  }, [_vm._v("part 1 - getting started")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c01_r1"
    }
  }, [_vm._v("foam roller: the magic bullet?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c02_r1"
    }
  }, [_vm._v("why use foam rollers?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("choosing a roller")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("before you begin")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safety")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting On and Off the Roller")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assessment")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part 2 - the programs")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("how to use this book")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("general fitness")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("proper posture")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("hamstring flexibility")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("shoulder flexibility")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("baseball/softball")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("basketball")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("boxing/mixed martial arts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cycling")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("football/rugby")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("golf")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("running/jogging/hiking")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rowing/kayaking")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("skiing: downhill/cross-country")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("swimming/surfing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c05_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tennis/racquetball")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part 3 - the exercises")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("seated series")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pelvic tilt")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ankle sequence")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("lying series")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine orientation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine stabilization—arms")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine stabilization—legs")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine stabilization—combination")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine marching")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine pelvic lift")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pelvic lift marching")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine leg press-out")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine I, Y & T")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine bench press")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("supine fly")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("prone reverse fly")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("push-up")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("plank to pike")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("spine extension")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c07_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("side salutation")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("kneeling series")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c08_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mad cat")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c08_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pointer sequence")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c08_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("hip flexor stretch")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c08_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("kneel stance")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c08_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("wrist stretch")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("standing series")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("roller squat")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("roller stand")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("standing slide")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("standing mini squat")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("standing ball pick-up")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tightrope walk")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rock and roll")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("one-leg balance")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sword fighter")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("frontal raise")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("lateral raise")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("skiing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("compound skiing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rotator cuff exercise")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("obstacle course")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c09_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tightrope challenge")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("massage series")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("gluteal massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("quad massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iliotibial band massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("inner thigh massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("calf massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("hamstring massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("arch rocks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("upper back massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("forearm massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("lat massage")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_c10_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("neck massage")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_in1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("index")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("other ulysses press books")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("about the author")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/karl_9781569759561_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fdd3b9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/karl_9781569759561_oeb_toc_r1.vue
// module id = 63
// module chunks = 0